import React, { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Form, Button, Spinner } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import cx from "classnames";

import global from "../../../scss/dhp.scss";
import { preventFormSubmitOnEnter as preventSubmit } from "../../../_helpers/utils";
import { Input } from "../../ui/input";
import { Icon } from "../../ui/icon";
import useLayoutGroup from "../../../hooks/useLayoutGroup";
import { fetchLayoutDetailsBySourceId, publishLayout } from "../../../store/actions/aiActions";
import { FlashAlert } from "../../ui/flashAlert";
import FormLoader from "../../ui/loader/formLoader";

let style = Object.assign({}, global);

const publishToLayoutLibraryModal = ({ document: data, _helpers }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { getLayouts } = useLayoutGroup();
  const modalName = data.published_library_layout ? "Republish to Layout Library" : "Publish to Layout Library";
  const ButtonName = data.published_library_layout ? "Republish" : "Publish";

  const alertData = {
    show: false,
    type: "",
  };

  const form = {
    group: {
      value: "",
      options: [],
      validation: {
        required: true,
      },
      valid: false,
    },
    format: {
      value: "",
      options: [],
      validation: {
        required: true,
      },
      valid: false,
    },
    type: {
      value: "",
      options: [],
      validation: {
        required: true,
      },
      valid: false,
    },
    category: {
      value: "",
      options: [],
      validation: {
        required: true,
      },
      valid: false,
    },
    tags: {
      value: [],
      valid: true,
    },
    theme: {
      value: false,
      valid: true,
    },
  };

  const [formData, setFormData] = useState(form);
  const [formValid, setFormValid] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isPublished, setIsPublished] = useState(false);
  const [alert, setAlert] = useState(alertData);
  const [showForm, setShowForm] = useState(false);
  const [loadOptions, setLoadOptions] = useState(false);
  const [layoutMasterId, setLayoutMasterId] = useState();

  const toggleAlert = () => setAlert({ ...alert, show: !alert.show });

  const checkValidity = (value, rules) => {
    let isValid = true;
    if (rules.required) isValid = value.trim() !== "" && isValid;
    return isValid;
  };

  const fetchLayoutInfoById = () => {
    dispatch(fetchLayoutDetailsBySourceId(data.id)).then(resp => {
      if (resp?.layout) {
        let currGroup, currFormats, currTypes, currCategories;
        let updatedForm = { ...formData };
        let latestData = resp.layout;
        if (latestData.layout_group) {
          updatedForm.group.value = latestData.layout_group;
          updatedForm.group.valid = true;
          currGroup = updatedForm.group.options.find(groupInfo => groupInfo.name === latestData.layout_group);
        }
        if (latestData.layout_format) {
          currFormats = currGroup.layout_formats;
          updatedForm.format.value = latestData.layout_format;
          updatedForm.format.options = currFormats;
          updatedForm.format.valid = true;
        }
        if (latestData.layout_type) {
          currTypes = currFormats.find(formatInfo => formatInfo.name === latestData.layout_format);
          updatedForm.type.value = latestData.layout_type;
          updatedForm.type.options = currTypes.layout_types;
          updatedForm.type.valid = true;
        }
        if (latestData.layout_category) {
          currCategories = currTypes.layout_types.find(typeInfo => typeInfo.name === latestData.layout_type);
          updatedForm.category.value = latestData.layout_category;
          updatedForm.category.options = currCategories.layout_categories;
          updatedForm.category.valid = true;
          let currCategoryInfo = currCategories.layout_categories.find(
            categoryInfo => categoryInfo.name === latestData.layout_category
          );
          if (currCategoryInfo?.id) setLayoutMasterId(currCategoryInfo.id);
        }
        if (latestData.keywords) updatedForm.tags.value = latestData.keywords;
        if (latestData.theme) updatedForm.theme.value = latestData.theme === "light" ? false : true;

        setFormData(updatedForm);
      }
      setTimeout(() => {
        setShowForm(true);
      }, 200);
    });
  };

  const updateForm = (e, field) => {
    let updatedForm = { ...formData };
    if (field !== "tags" && field !== "theme") {
      updatedForm[field].value = e.name;
      updatedForm[field].valid = checkValidity(updatedForm[field].value, updatedForm[field].validation);
    }

    if (field === "group") {
      updatedForm.format.options = e.layout_formats;
      updatedForm.type.options = [];
      updatedForm.category.options = [];

      // remove tagged value
      updatedForm.format.value = "";
      updatedForm.format.valid = false;

      updatedForm.type.value = "";
      updatedForm.type.valid = false;

      updatedForm.category.value = "";
      updatedForm.category.valid = false;
      setLayoutMasterId();
    } else if (field === "format") {
      updatedForm.type.options = e.layout_types;
      updatedForm.category.options = [];

      updatedForm.type.value = "";
      updatedForm.type.valid = false;

      updatedForm.category.value = "";
      updatedForm.category.valid = false;
      setLayoutMasterId();
    } else if (field === "type") {
      updatedForm.category.options = e.layout_categories;

      updatedForm.category.value = "";
      updatedForm.category.valid = false;
      setLayoutMasterId();
    } else if (field === "category") {
      setLayoutMasterId(e.id);
    } else if (field === "tags") {
      updatedForm[field].value = e;
    } else if (field === "theme") {
      updatedForm[field].value = e;
    }

    setFormData(updatedForm);
    setFormValid(!Object.keys(formData).some(field => !formData[field].valid));
  };

  const handleSubmit = e => {
    e.preventDefault();
    let payload = {
      name: data.document_name,
      keywords: formData.tags.value,
      layout_master_id: layoutMasterId,
      source_document_id: data.id,
      theme: formData.theme.value ? "dark" : "light",
    };
    setIsUploading(true);
    dispatch(publishLayout(payload)).then(resp => {
      setIsUploading(false);
      setIsPublished(true);

      setAlert({
        ...alert,
        show: true,
        type: resp.success ? "success" : "error",
        message: resp.success ? "Layout has been published to library" : "Somthing went wrong",
        fadeIn: 5000,
      });
    });
  };

  // Fetch document list after publish to layout library
  useEffect(() => {
    if (isPublished) {
      setIsPublished(false);
      _helpers.modal.toggle();
      if (_helpers.ref === "documents") {
        _helpers.gridView.fetch.setPayload({ ..._helpers.gridView.fetch.payload, page: 1 });
      }
      if (_helpers.ref === "editor") {
        history.go(0);
      }
    }
  }, [isPublished]);

  useLayoutEffect(() => {
    const loadLayouts = async () => {
      const layouts = await getLayouts();
      let curreFormData = { ...formData };
      curreFormData.group.options = layouts;
      setFormData(curreFormData);
      setLoadOptions(true);
    };

    loadLayouts();
  }, [getLayouts]);

  useEffect(() => {
    if (showForm) return;
    if (!loadOptions) return;
    if (data.published_library_layout) fetchLayoutInfoById();
    else setShowForm(true);
  }, [loadOptions]);

  return (
    <React.Fragment>
      <h4 className={cx(style["fw-7"], style["mb-4"])}>{modalName}</h4>
      <Link to="#" className={cx(style["cross-modal"], style["rounded"])} onClick={_helpers?.modal?.toggle}>
        <Icon icon="ui-close" />
      </Link>
      {!showForm && (
        <div className={style["publish-layout-loader"]}>
          <FormLoader doubleCol={false} lineCount={2} sectionCount={2} colCount={12} hideCommonLine={true} />
        </div>
      )}
      {showForm && (
        <Form onKeyDown={e => preventSubmit(e)} onSubmit={e => handleSubmit(e)}>
          <div className={cx(style["customScroll"], style["scroll-Y"], style["mb-4"], style["px-2"])}>
            <Input
              cssModule={style}
              returnType="formGroup"
              type="dropdown"
              label="Layout Group"
              required={true}
              classNamePrefix="select"
              getOptionValue={option => option?.name}
              getOptionLabel={option => <span>{option?.name}</span>}
              options={formData.group.options}
              updateState={e => updateForm(e, "group")}
              defaultValue={{ name: formData.group.value }}
            />
            <Input
              cssModule={style}
              returnType="formGroup"
              type="dropdown"
              label="Layout Format"
              required={true}
              classNamePrefix="select"
              getOptionValue={option => option?.name}
              getOptionLabel={option => <span>{option?.name}</span>}
              options={formData.format.options}
              updateState={e => updateForm(e, "format")}
              defaultValue={{ name: formData.format.value }}
            />

            <Input
              cssModule={style}
              returnType="formGroup"
              type="dropdown"
              label="Layout Type"
              required={true}
              classNamePrefix="select"
              getOptionValue={option => option?.name}
              getOptionLabel={option => <span>{option?.name}</span>}
              options={formData.type.options}
              updateState={e => updateForm(e, "type")}
              defaultValue={{ name: formData.type.value }}
            />

            <Input
              cssModule={style}
              returnType="formGroup"
              type="dropdown"
              label="Layout Category"
              required={true}
              classNamePrefix="select"
              getOptionValue={option => option?.name}
              getOptionLabel={option => <span>{option?.name}</span>}
              options={formData.category.options}
              updateState={e => updateForm(e, "category")}
              defaultValue={{ name: formData.category.value }}
            />

            <Input
              returnType="formGroup"
              type="tag"
              label="Keywords"
              defaultValue={formData.tags.value}
              updateState={e => updateForm(e, "tags")}
            />

            <div className={cx(style["form-check"], style["form-switch"], style["lr-label"], style["mb-4"])}>
              <span className={style["left"]}>Light</span>
              <Input
                cssModule={style}
                returnType="noGroup"
                type="checkbox"
                className={cx(style["form-check-input"], style["ml-1"])}
                id="theme-toggle"
                label="Dark"
                defaultChecked={formData.theme.value}
                onChange={e => updateForm(e, "theme")}
              />
            </div>
          </div>
          <div className={cx(style["align-items-center"], style["d-flex"])}>
            <Button type="submit" color="primary" cssModule={style} disabled={!formValid || isUploading}>
              {ButtonName}
            </Button>
            {isUploading && <Spinner size="sm" color="dark" className="ml-2" />}

            <FlashAlert
              isOpen={alert.show}
              toggle={toggleAlert}
              type={alert.type}
              wrapperClass="ms-2"
              message={alert.message}
              fadeIn={alert?.fadeIn}
            />
          </div>
        </Form>
      )}
    </React.Fragment>
  );
};

export default publishToLayoutLibraryModal;
